module.exports = __webpack_public_path__ + "img/easypaper_prod.29126f7d.png";